module.exports = __webpack_public_path__ + "media/images/wealthbar/2fa/twofactor-verified-fbf505798c35032611b3db91e85a6ae3.svg";